import React from 'react'
//import {useState} from 'react'
import styled from 'styled-components'
//import CoverVideo from '../CoverVideo'
//import Mintvideo from '../Mintvideo'
//import Covervideomob from '../Covervideomob'
//import { ethers } from 'ethers';
import img1 from '../../assets/Nfts/websitebanner.png';
//import img2 from '../../assets/Nfts/cloud_2.png';
//import { ethers } from "ethers";
import MintButton from '../MintButton';


const Section = styled.section`
min-height: ${props => `calc(100vh - ${props.theme.navHeight})`
};
width:100vw;
position: relative;
background-color: #9ed2ef;
`
const SubText = styled.p`
font-size: ${props => props.theme.fontmd};

width: 100%;
color: ${props => props.theme.text};
align-self: center;
margin-top: 1rem auto;
margin: 1rem auto;
justify-content: center;
  text-align: center;
@media (max-width: 64em){
  align-self: center;
  justify-content: center;
  text-align: center;
  font-size: ${props => props.theme.fontmd};
  }

`
const Container = styled.div`
width: 85%;
height: auto;
margin: 0 auto;
background-color: #9ed2ef;
display: flex;
justify-content: center;
align-items: center;

img{
  width: 100%;
  height: auto;
  
  }

@media (min-width: 75em){
  width: 65%;
  }

@media (max-width: 64em){
  width: 60%;
  }
  @media (max-width: 55em){
    width: 70%;
  
    }
    @media (max-width: 48em){
      width: 100%;
    
      }

  @media (max-width: 48em){
  flex-direction: column-reverse;

  }

  .mobile {
    display: none;
  }
  
  @media (max-width: 64em)
  {
    .desktop{
    display: none;

    
    }
    
    @media (max-width: 64em)
    {
      .mobile{
      display: flex;
      justify-content: center;
align-items: center;
  
      
      }
      

`
const Title = styled.h1`
font-family: "Caveat Brush", cursive;
font-size: ${props => props.theme.fontxxxl};
text-transform: capitalize;
color: ${props => props.theme.text};
align-self: center;
justify-content: center;
margin: 1rem auto;
display: flex;
width: fit-content;
@media (max-width: 48em){
  font-size: ${props => props.theme.fontxxl};
}

`

const Box = styled.div`
width: 100%;
height: 100%;
text-align: center;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

@media (max-width: 64em){
  width: 100%;
  }

  .desktop {
  @media (min-width: 48em)
  {
    
    display: none;

    }
  }
`


const Mint = () => {
 /* const [account, setAccount] = useState(null);
  const initConnection = async () => {
    if(typeof window.ethereum !== "undefined"){
    const accounts = await window.ethereum.request({
    method: "eth_requestAccounts",
    });
    
      
      setAccount(accounts[0]);
    }
    else {
      console.log("bajs");
    }
    
    }*/

  return (
    <Section id="mint">
      
      
      <Container>
      <img src={img1} alt=""></img>
      
      </Container>
     <Title></Title><SubText></SubText>
      
      <Box>
      <MintButton />
      </Box>
      <Box>
      <div class="desktop"><p>Mobile mint not available</p></div>
      </Box>
    </Section>
  )
}

export default Mint